import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.heading',
		defaultMessage: 'Jira',
		description: 'Navigation group heading for Jira settings items',
	},
	configurationItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.configuration-item',
		defaultMessage: 'Jira configuration',
		description: 'Navigation item which links to a Jira configuration settings page',
	},
	storeManagementItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.store-management-item',
		defaultMessage: 'Storage management',
		description: 'Navigation item which links to a Jira storage management page',
	},
	guestAccessItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.guest-access-item.non-final',
		defaultMessage: 'Site access',
		description: 'Navigation item which links to a Jira guest access configuration page',
	},
	onboardingHubItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.onboarding-hub-item',
		defaultMessage: 'Custom onboarding',
		description: 'Navigation item which links to the Onboarding Hub page',
	},
	newLabel: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.new-label',
		defaultMessage: 'New',
		description: 'Lozenge marking the menu item as new item',
	},
	premiumLabel: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.jira-section.premium-label',
		defaultMessage: 'Premium',
		description: 'Lozenge marking the menu item as premium item',
	},
});
